/** Shared dashboard chart section chrome (BarChart, ProjectBreakdown, …). */
import { STATIC_CARD_BORDER_SX } from '@/components/ui/staticCardBorderSx';

export const DASHBOARD_SECTION_SX = {
  ...STATIC_CARD_BORDER_SX,
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  width: '100%',
  p: 2,
  bgcolor: 'background.paper',
  mb: 2,
};

export const DASHBOARD_SECTION_TITLE_SX = {
  fontWeight: 600,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
};

/** Roving listbox container focus ring (option outline uses isActive && hasFocus). */
export const DASHBOARD_ROVING_LISTBOX_SX = {
  outline: 'none',
  '&:focus-visible': {
    outline: '2px solid',
    outlineColor: 'primary.main',
    outlineOffset: 2,
    borderRadius: 1,
  },
};

/** Per-option outline while listbox has keyboard focus. */
export const rovingBarOptionSx = (isActive, hasFocus) => ({
  outline: isActive && hasFocus ? '2px solid' : 'none',
  outlineColor: 'primary.main',
  outlineOffset: 1,
});
